import MYContainer from "./MYContainer";

/*
* 사용자 분석 및 통계 페이지
*/
export default MYContainer;